export const listCompaniesEndpoint = (tenantId: string): string => {
  const query = new URLSearchParams({ tenant_id: tenantId })
  return `/berths/bookings/list_companies?${query.toString()}`
}
